export const RECIPE_INFO = {
    'Alkalinity: Sodium Bicarbonate (NaHCO3)': {
        ingredients: `Sodium bicarbonate, USP/food-grade (plain baking soda, no additives). RO/DI water.`,
        equipment: `Gram scale (0.01 g), graduated mixing bottle, clean funnel, stir stick.`,
        storage: `Sealed bottle, room temperature, out of direct light. Indefinite shelf life; re-dissolve if any settles.`,
        usageTips: `Keep alkalinity 8–9 dKH for most reefs. Don't raise more than ~1.4 dKH/day; split larger corrections. Dose into high-flow, away from corals.`,
    },
    'Alkalinity: Sodium Carbonate (Na2CO3)': {
        ingredients: `Sodium carbonate (soda ash) — or bake plain NaHCO3 at 300°C/575°F for ~1 hour. RO/DI water.`,
        equipment: `Gram scale, oven + baking sheet (if making your own), graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite; keep dry powder airtight.`,
        usageTips: `Stronger pH push than bicarb; dose in the morning/with lights to avoid nighttime pH dips. Max ~1.4 dKH/day.`,
    },
    'Alkalinity: Sodium Hydroxide (NaOH)': {
        ingredients: `Sodium hydroxide, high-purity (food/reagent grade) beads or pellets. RO/DI water.`,
        equipment: `Gram scale, chemical-resistant gloves, goggles, graduated bottle, stir stick; mix in a well-ventilated area.`,
        storage: `Sealed (it absorbs CO2 from air, slowly weakening), room temp, dark, labeled CAUSTIC. Use within a few months.`,
        usageTips: `Very fast pH movement — dose small amounts into high flow and recheck pH. Often dosed slowly via a doser. Max ~1.4 dKH/day.`,
    },
    'Calcium: Calcium Chloride Dihydrate (CaCl2·2H2O)': {
        ingredients: `Calcium chloride dihydrate, food/pharma grade (e.g. BRS dry CaCl2). RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick, gloves.`,
        storage: `Sealed (the dry salt is hygroscopic — keep airtight), room temp. Solution keeps indefinitely.`,
        usageTips: `Keep Ca 400–450 ppm. Dose as the "Part 2" balanced with an alkalinity "Part 1." Max ~50 ppm/day; split larger corrections.`,
    },
    'Magnesium: Balanced Supplement (Blend)': {
        ingredients: `Magnesium chloride hexahydrate, magnesium sulfate heptahydrate (Epsom salt), RO/DI water.`,
        equipment: `Gram scale or measuring cups, 1-gallon jug, stir stick, gloves.`,
        storage: `Sealed, room temp. Keeps indefinitely; shake if any settles.`,
        usageTips: `Keep Mg 1300–1400 ppm. Correct low Mg before chasing Ca/Alk. Max ~100 ppm/day.`,
    },
    'RHF Alkalinity (Part 1)': {
        ingredients: `Sodium carbonate (or baked NaHCO3), RO/DI water. (Randy's exact: 2 cups soda ash per gallon.)`,
        equipment: `Oven (if baking), gram scale/measuring cup, 1-gal jug, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Dose Part 1 and Part 2 in equal volumes but NEVER simultaneously/in the same spot (they precipitate). Stagger by time or dose in separate flow areas.`,
    },
    'RHF Calcium (Part 2)': {
        ingredients: `Calcium chloride dihydrate, RO/DI water. (Randy's exact: ~2.5 cups CaCl2·2H2O per gallon.)`,
        equipment: `Gram scale/cup, 1-gal jug, stir stick, gloves.`,
        storage: `Sealed, room temp. Indefinite.`,
        usageTips: `Equal volume to Part 1, dosed separately. Keep Ca 400–450, Alk 8–9 dKH, balanced.`,
    },
    'RHF Magnesium': {
        ingredients: `Magnesium chloride hexahydrate, magnesium sulfate heptahydrate, RO/DI water.`,
        equipment: `Measuring cups/scale, 1-gal jug, stir stick, gloves.`,
        storage: `Sealed, room temp. Indefinite.`,
        usageTips: `Keep Mg 1300–1400 ppm. Max ~100 ppm/day. The 5:3 MgCl2:MgSO4 ratio is Randy's authentic recipe.`,
    },
    'Phosphate Remover: Lanthanum Chloride (LaCl3)': {
        ingredients: `Commercial LaCl3 concentrate (e.g. SeaKlear/Phosphate-RX), RO/DI water.`,
        equipment: `Filter sock or fine media, dosing pump or slow-drip line, RO/DI for dilution, gloves.`,
        storage: `Concentrate and working solution: sealed, room temp, dark.`,
        safety: `⚠ Never dose fast or directly into the display — precipitate in the water column can cause severe gill/respiratory distress in fish. Always filter it out.`,
        usageTips: `Lower phosphate gradually (≤0.05 ppm/day). Over-stripping PO4 can trigger dinoflagellates. Run a skimmer.`,
    },
    'Nitrogen: Ammonium Bicarbonate ((NH4)HCO3)': {
        ingredients: `Ammonium bicarbonate (reagent/food grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick, gloves.`,
        storage: `Sealed, refrigerated ideally (it can off-gas ammonia), dark. Mix fresh every 1–2 months.`,
        usageTips: `Values are total ammonia as NH3 (multiply ×0.82 if your kit reads NH3-N). For ULNS only; dose to a target NO3 of ~2–5 ppm via assimilation. Never dose if any measurable ammonia is present.`,
    },
    'Nitrogen: Ammonium Chloride (NH4Cl)': {
        ingredients: `Ammonium chloride (reagent/food grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick, gloves.`,
        storage: `Sealed, room temp, dark. More stable than the bicarbonate form; keeps several months.`,
        usageTips: `Total ammonia as NH3 basis (×0.82 for NH3-N kits). Watch alkalinity over time. ULNS use only; never dose with measurable ammonia present.`,
    },
    'Nitrogen: Sodium Nitrate (NaNO3)': {
        ingredients: `Sodium nitrate (reagent/food grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Target NO3 ~2–10 ppm depending on system; keep an N:P near 100:1 by mass. Raise gradually.`,
    },
    'Nitrogen: Potassium Nitrate (KNO3)': {
        ingredients: `Potassium nitrate (reagent/food grade / stump remover that is pure KNO3), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Adds K as a bonus; if K is already high, prefer NaNO3. Target NO3 ~2–10 ppm.`,
    },
    'Phosphate: Trisodium Phosphate (Na3PO4)': {
        ingredients: `Trisodium phosphate, reagent grade (NOT hardware-store TSP cleaners with additives), RO/DI water.`,
        equipment: `Precision scale (0.001 g if possible), graduated bottle, stir stick, gloves.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Target PO4 ~0.03–0.10 ppm. Raise slowly; this is very strong per gram. Na3PO4 also nudges alkalinity/pH up slightly.`,
    },
    'Phosphate: Monopotassium Phosphate (KH2PO4)': {
        ingredients: `Monopotassium phosphate, reagent grade, RO/DI water.`,
        equipment: `Precision scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Milder/safer than Na3PO4 for fine control. Target PO4 ~0.03–0.10 ppm.`,
    },
    'Coral Snow (Calcium Carbonate)': {
        ingredients: `Fine/precipitated calcium carbonate (aragonite) powder, RO/DI water.`,
        equipment: `Bottle, scale, vigorous shaker (it's a suspension, not a solution).`,
        storage: `Sealed, room temp. Powder settles — always shake before use.`,
        usageTips: `Often paired with an organic/bacterial additive to clarify and feed corals. Shake before each use.`,
    },
    'Strontium (SrCl2·6H2O)': {
        ingredients: `Strontium chloride hexahydrate (reagent grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick, gloves.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Target Sr ~8–10 ppm (NSW level). Only dose if you test; excess does nothing useful.`,
    },
    'Iron (Ferrous Gluconate)': {
        ingredients: `Ferrous gluconate (dihydrate, the common commercial form), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, refrigerate to slow oxidation, dark. Mix fresh every ~1–2 months (chelated iron degrades).`,
        usageTips: `Dose to the refugium/chaeto, not the display, in tiny amounts. Iron is consumed fast; don't chase a test number.`,
    },
    'Silicate (Na2SiO3)': {
        ingredients: `Sodium silicate concentrate ("water glass"), RO/DI water.`,
        equipment: `Graduated bottle, gloves, stir stick.`,
        storage: `Sealed, room temp. Glass or HDPE bottle (it's caustic).`,
        safety: `⚠ Alkaline/caustic concentrate — gloves and eye protection.`,
        usageTips: `Dose conservatively; too much silica can cause a nuisance diatom bloom. Mostly used deliberately as a dino-fighting tool.`,
    },
    'Manganese (MnCl2·4H2O)': {
        ingredients: `Manganese chloride tetrahydrate (reagent grade), RO/DI water.`,
        equipment: `Precision scale, two 1 L bottles, accurate 1 mL pipette.`,
        storage: `Sealed, room temp, dark. Mix fresh working stock every 1–2 months.`,
        usageTips: `Trace element — dose tiny amounts only with ICP testing. Easy to overdose without dilution.`,
    },
    'Potassium (KCl)': {
        ingredients: `Potassium chloride (reagent/food grade, e.g. salt-free "salt substitute" that is pure KCl), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp. Indefinite.`,
        usageTips: `Target K ~390–420 ppm (NSW). Test before dosing; excess K is hard to remove except via water changes.`,
    },
    'Iodide (KI)': {
        ingredients: `Potassium iodide (reagent grade), RO/DI water.`,
        equipment: `Gram scale, amber/opaque bottle, stir stick.`,
        storage: `Sealed AMBER bottle, dark, room temp. Mix fresh every few months.`,
        usageTips: `Target iodine ~0.06 ppm (NSW); iodide is consumed quickly. Dose small, frequent amounts; overdose harms shrimp.`,
    },
    'Bromide (NaBr)': {
        ingredients: `Sodium bromide (reagent grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Target ~65 ppm. Bromide is rarely depleted in tanks with regular water changes — test (ICP) first.`,
    },
    'Fluoride (NaF)': {
        ingredients: `Sodium fluoride (reagent grade), RO/DI water.`,
        equipment: `Precision scale, graduated bottle, gloves, stir stick.`,
        storage: `Sealed, room temp, dark, labeled (fluoride is toxic concentrated). Indefinite.`,
        safety: `⚠ Sodium fluoride is toxic if ingested — gloves, label clearly, keep from children/pets.`,
        usageTips: `Target ~1.3 ppm (NSW). Dose only with ICP testing; consumption is slow.`,
    },
    'Zinc (ZnSO4·7H2O)': {
        ingredients: `Zinc sulfate heptahydrate (reagent grade), RO/DI water.`,
        equipment: `Precision scale, two 1 L bottles, accurate 10 mL pipette.`,
        storage: `Sealed, room temp, dark. Mix fresh secondary every 1–2 months.`,
        usageTips: `Trace element — ICP-guided only. Easy to overdose; zinc toxicity harms inverts.`,
    },
    'Boron (H3BO3)': {
        ingredients: `Boric acid (reagent grade), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, gloves, stir stick.`,
        storage: `Sealed, room temp, dark. Indefinite.`,
        usageTips: `Target ~4.5 ppm. Usually replenished by water changes; ICP-test before dosing.`,
    },
    'DIY Alkalinity Titration Test': {
        ingredients: `Muriatic acid (for the titrant), bromocresol green + methyl red indicator, RO/DI water, a salinity/calibration check.`,
        equipment: `Class A volumetric flasks, accurate burette or 1 mL syringe, sample pipette, small beaker.`,
        safety: `⚠ Muriatic acid is corrosive — gloves, goggles, ventilation; always add acid to water.`,
        usageTips: `Standardize your titrant against the DIY primary standard for accuracy.`,
    },
    'DIY Alkalinity Primary Standard': {
        ingredients: `Primary-standard anhydrous Na2CO3 (oven-dried), RO/DI water.`,
        equipment: `Analytical balance (0.001 g), 1 L Class A volumetric flask, drying oven, desiccator.`,
        usageTips: `Make fresh; store sealed. Use to set the zero/calibration of test gear.`,
    },
    'DIY Salinity Calibration Standard': {
        ingredients: `Pure non-iodized NaCl (no anti-caking agents), RO/DI water.`,
        equipment: `Analytical balance, sealable bottle.`,
        usageTips: `Use at the same temperature as your refractometer's ATC reference (~25°C). For refractometers only.`,
    },
    'Nitrogen (from Potassium Nitrate - KNO3)': {
        ingredients: `Potassium nitrate (water-soluble, pure), RO/DI or dechlorinated water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, cool, dark. Refrigerate or add preservative for long storage.`,
        usageTips: `EI dosing target ~10–30 ppm NO3 weekly for high-tech tanks. Adjust by growth + nitrate test.`,
    },
    'Phosphorus (from Monopotassium Phosphate - KH2PO4)': {
        ingredients: `Monopotassium phosphate (pure), RO/DI or dechlorinated water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, cool, dark.`,
        usageTips: `EI target ~1–3 ppm PO4 weekly. Often combined with KNO3 in a macro mix.`,
    },
    'Potassium (from Potassium Sulfate - K2SO4)': {
        ingredients: `Potassium sulfate (pure), RO/DI or dechlorinated water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, cool, dark.`,
        usageTips: `EI target ~10–30 ppm K weekly. Use this when N and P are already where you want them.`,
    },
    'Calcium (from Calcium Chloride Dihydrate - CaCl2·2H2O)': {
        ingredients: `Calcium chloride dihydrate (pure), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick, gloves.`,
        storage: `Sealed, room temp; keep dry salt airtight (hygroscopic).`,
        usageTips: `Re-mineralize RO/DI to ~10–30 ppm Ca for plants/shrimp; maintain a Ca:Mg ratio ~3–4:1.`,
    },
    'Magnesium (from Magnesium Sulfate Heptahydrate - MgSO4·7H2O)': {
        ingredients: `Magnesium sulfate heptahydrate (Epsom salt, pure), RO/DI water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp.`,
        usageTips: `Re-mineralize RO/DI to ~3–10 ppm Mg, keeping Ca:Mg ~3–4:1.`,
    },
    'Alkalinity (from Potassium Bicarbonate - KHCO3)': {
        ingredients: `Potassium bicarbonate (pure), RO/DI or dechlorinated water.`,
        equipment: `Gram scale, graduated bottle, stir stick.`,
        storage: `Sealed, room temp, dark.`,
        usageTips: `Keep KH ~3–5 dKH for planted/CO2 tanks. Raising KH with KHCO3 also nudges potassium up.`,
    },
    'Consolidated Trace Mix (Recommended Method)': {
        ingredients: `Per 1 L: 15.00 g ferrous gluconate · 3.50 g manganese chloride tetrahydrate · 2.00 g boric acid · 0.40 g zinc sulfate heptahydrate · 0.15 g sodium molybdate dihydrate · 0.08 g copper (II) sulfate pentahydrate. RO/DI water.`,
        equipment: `Precision scale, 1 L bottle, stir stick, gloves.`,
        storage: `Sealed, refrigerated, dark. Mix fresh every ~1–2 months even with preservative.`,
        safety: `Copper sulfate is toxic — gloves, label, keep from pets/kids.`,
        usageTips: `EI micro dosing ~3x/week, alternating days with macros. Never mix with the macro/PO4 bottle.`,
    },
    'Mastering Carbon Dioxide (CO2) Injection': {
        equipment: `CO2 cylinder, regulator + solenoid, bubble counter, diffuser/reactor, drop checker (4 dKH reference + bromocresol indicator), pH controller (optional).`,
        safety: `⚠ Too much CO2 suffocates fish — watch for surface gasping; add surface agitation/air at night. Secure the cylinder.`,
        usageTips: `A green drop checker = ~30 ppm CO2. Pair high CO2 with high light + ferts, or you get algae.`,
    },
};
//# sourceMappingURL=recipe-info.js.map